import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 5;
  opacity: 0.5;
`;

const Logo = styled.div`
  width: 100px;
  height: 100px;
  border: 2px solid #00ff00;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  text-align: center;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.7);
`;

const LumonLogo = () => {
  return (
    <LogoContainer>
      <Logo>
        LUMON INDUSTRIES
        <br />
        EST. 1866
      </Logo>
    </LogoContainer>
  );
};

export default LumonLogo;
